import { combineReducers } from 'redux'
import coreReducer from './core/coreReducer'
import errorReducer from './error/errorReducer'
import authReducer from './auth/authReducer'

const rootReducer = combineReducers({
  core: coreReducer,
  error: errorReducer,
  auth: authReducer,
})

export default rootReducer
